"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCustomer = exports.searchCustomer = exports.valuesLens = void 0;
const t = require("io-ts");
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const validation_1 = require("../../utils/validation");
const errorHandling_1 = require("../../utils/errorHandling");
const customerActionTypes = require("../../actionTypes/firstLogin/customer");
const actions = require("../../actions/firstLogin/customer");
const formActions = require("../../actions/firstLogin/form");
const sok_types_1 = require("@caddigital/sok-types");
exports.valuesLens = monocle.Lens.fromProp('values');
const validateCustomer = (store) => {
    return exports.valuesLens
        .asOptional()
        .getOption(store)
        .fold(fp.validation.failure([
        {
            key: 'any',
            value: 'Unhandled exception'
        }
    ]), (x) => {
        const val = fp.function.compose(fp.function.compose((0, validation_1.ap)((0, validation_1.isNotEmpty)('name')(x)), (0, validation_1.ap)((0, validation_1.isNotEmpty)('street')(x)), (0, validation_1.ap)((0, validation_1.isNotEmpty)('postalCode')(x)), (0, validation_1.ap)((0, validation_1.isNotEmpty)('city')(x)), (0, validation_1.ap)((0, validation_1.isNotEmpty)('country')(x))), fp.function.compose((0, validation_1.ap)((0, validation_1.hasInvalidLength)('name', null, 150)(x.name)), (0, validation_1.ap)((0, validation_1.hasInvalidLength)('street', null, 50)(x.street)), (0, validation_1.ap)((0, validation_1.hasInvalidLength)('postalCode', null, 20)(x.postalCode)), (0, validation_1.ap)((0, validation_1.hasInvalidLength)('city', null, 50)(x.city))))((0, validation_1.hasInvalidLength)('country', null, 50)(x.country));
        if (x.hasBusinessId) {
            return (0, validation_1.ap)((0, validation_1.isNotEmpty)('businessId')(x))(val);
        }
        else {
            return val;
        }
    });
};
function searchCustomer(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === customerActionTypes.SEARCH_CUSTOMER_REQUEST), (0, operators_1.debounceTime)(200), (0, operators_1.switchMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/customer/search/${request.payload}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t.array(sok_types_1.Customer.iCustomer).decode(response);
        const act = validation.fold((err) => actions.searchCustomerFailed((0, errorHandling_1.parseValidationError)(err)), (e) => actions.searchCustomerSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.searchCustomerFailed((0, errorHandling_1.parseAjaxErrorResponse)(err)))))));
}
exports.searchCustomer = searchCustomer;
function createCustomer(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === customerActionTypes.CREATE_CUSTOMER_REQUEST), (0, operators_1.mergeMap)((request) => validateCustomer(store.value.firstLogin.customer).fold((e) => (0, rxjs_1.of)(actions.validateCustomerFailure(e)), () => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: request.payload,
        url: `${baseUrl}api/customer/`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        return sok_types_1.Customer.iCustomer.decode(response).fold((err) => (0, rxjs_1.of)(actions.createCustomerFailed((0, errorHandling_1.parseValidationError)(err))), (e) => (0, rxjs_1.merge)((0, rxjs_1.of)(actions.createCustomerSuccess(e)).pipe((0, operators_1.delay)(500)), (0, rxjs_1.of)(formActions.setCompany(e.id)).pipe((0, operators_1.delay)(500)), (0, rxjs_1.of)(actions.toggleNewCustomerModal(false)).pipe((0, operators_1.delay)(1500))));
    }), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.createCustomerFailed((0, errorHandling_1.parseAjaxErrorResponse)(err))))))));
}
exports.createCustomer = createCustomer;
//# sourceMappingURL=customer.js.map